import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiEye, FiHeart, FiShield, FiTarget, FiZap}=FiIcons;

const HeroSection=()=> {
  return (
    <section className="relative min-h-screen flex items-center justify-center px-4 py-20 overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-gradient-to-br from-pink-900/20 via-purple-900/30 to-slate-900/40"></div>
      <div className="absolute top-20 left-10 w-32 h-32 bg-pink-500/10 rounded-full blur-xl animate-pulse"></div>
      <div className="absolute bottom-20 right-10 w-40 h-40 bg-purple-500/10 rounded-full blur-xl animate-pulse delay-1000"></div>
      
      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        
        <motion.h1
          initial={{y: 30,opacity: 0}}
          animate={{y: 0,opacity: 1}}
          transition={{duration: 0.8,delay: 0.2}}
          className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight pt-12"
        >
          คุณแน่ใจเหรอ... ว่าคนที่นั่งข้างๆ<br />
          <span className="bg-gradient-to-r from-pink-400 to-purple-400 bg-clip-text text-transparent">
            คือ "มิตรแท้"?
          </span>
        </motion.h1>

        <motion.p
          initial={{y: 20,opacity: 0}}
          animate={{y: 0,opacity: 1}}
          transition={{duration: 0.8,delay: 0.4}}
          className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto"
        >
          หยุดใช้ความรู้สึกตัดสินคน... เพราะ <span className="text-pink-400 font-semibold">"หน้ากาก"</span> ดูง่าย 
          แต่ <span className="text-purple-400 font-semibold">"ธาตุแท้"</span> ดูยาก
        </motion.p>

        <motion.div
          initial={{y: 20,opacity: 0}}
          animate={{y: 0,opacity: 1}}
          transition={{duration: 0.8,delay: 0.6}}
          className="mb-12"
        >
          <h2 className="text-2xl md:text-3xl font-semibold text-white mb-6">
            ติดตั้งระบบ <span className="text-pink-400">"Human X-Ray"</span> ให้ตัวคุณ ด้วย
          </h2>

          {/* Course Logo */}
          <motion.div 
            initial={{scale: 0.8,opacity: 0}}
            animate={{scale: 1,opacity: 1}}
            transition={{duration: 0.8,delay: 0.7}}
            className="flex justify-center mb-6"
          >
            <img 
              src="https://static.wixstatic.com/media/4fbfa6_8804ccccd28e4d44984b827fadd01360~mv2.png" 
              alt="Bazi Love Logo" 
              className="w-48 md:w-64 h-auto drop-shadow-[0_0_15px_rgba(236,72,153,0.5)] hover:scale-105 transition-transform duration-500"
            />
          </motion.div>

          {/* fengshuiX Logo */}
          <motion.div 
            initial={{scale: 0.8,opacity: 0}}
            animate={{scale: 1,opacity: 1}}
            transition={{duration: 0.8,delay: 0.75}}
            className="flex justify-center mb-6"
          >
            <img 
              src="https://static.wixstatic.com/media/4fbfa6_be75bd70432e4b5aa62c8555bb24df83~mv2.png" 
              alt="fengshuiX Logo" 
              className="w-32 md:w-48 h-auto drop-shadow-[0_0_10px_rgba(236,72,153,0.3)] hover:scale-105 transition-transform duration-500"
            />
          </motion.div>

          <h3 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-pink-400 to-purple-400 bg-clip-text text-transparent mb-4">
            Bazi Love & Relationships
          </h3>
        </motion.div>

        <motion.p
          initial={{y: 20,opacity: 0}}
          animate={{y: 0,opacity: 1}}
          transition={{duration: 0.8,delay: 0.8}}
          className="text-lg md:text-xl text-gray-300 mb-10"
        >
          อ่านคนขาดทะลุถึงกระดูก... แม่นยำกว่า MBTI ลึกซึ้งกว่าจิตวิทยา และโกหกกันไม่ได้!
        </motion.p>

        <motion.div
          initial={{scale: 0.9,opacity: 0}}
          animate={{scale: 1,opacity: 1}}
          transition={{duration: 0.8,delay: 1}}
        >
          <button className="group relative px-8 py-4 bg-gradient-to-r from-pink-500 to-purple-600 text-white font-bold text-xl rounded-full shadow-2xl hover:shadow-pink-500/25 transition-all duration-300 transform hover:scale-105 border border-pink-400/50">
            <span className="flex items-center space-x-2">
              <SafeIcon icon={FiTarget} className="text-2xl" />
              <span>จองที่นั่งทันที! (อ่านคนให้ขาด ก่อนจะพลาดท่า)</span>
            </span>
            <div className="absolute inset-0 bg-gradient-to-r from-pink-600 to-purple-700 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"></div>
          </button>
          
          <p className="text-pink-300 mt-4 font-semibold">
            รุ่นพิเศษ: 21-22 ก.พ. 2569
          </p>
        </motion.div>

        {/* Feature Icons */}
        <motion.div
          initial={{y: 30,opacity: 0}}
          animate={{y: 0,opacity: 1}}
          transition={{duration: 0.8,delay: 1.2}}
          className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-2xl mx-auto"
        >
          {[
            {icon: FiEye,text: "อ่านคนแม่นยำ"},
            {icon: FiHeart,text: "เข้าใจความสัมพันธ์"},
            {icon: FiShield,text: "ป้องกันคนอันตราย"},
            {icon: FiZap,text: "เปลี่ยนชีวิตทันที"}
          ].map((item,index)=> (
            <div key={index} className="text-center">
              <div className="w-16 h-16 mx-auto bg-gradient-to-br from-pink-500/20 to-purple-500/20 rounded-full flex items-center justify-center border border-pink-500/30 backdrop-blur-sm mb-3">
                <SafeIcon icon={item.icon} className="text-2xl text-pink-400" />
              </div>
              <p className="text-gray-300 text-sm font-medium">{item.text}</p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;